import { Container, Row, Col } from 'react-bootstrap';
import { FaLinkedin } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="site-footer">
      <Container>
        <Row className="align-items-center gy-3">
          <Col md={6}>
            <div className="footer-brand">SalesFractionPro</div>
            <div className="footer-note">
              Based in Toronto | Serving clients across North America and Europe
            </div>
          </Col>
          <Col md={6} className="text-md-end">
            <div className="footer-contact">info@salesfractionpro.com</div>
            <div className="footer-links">
              <a
                href="https://www.linkedin.com/company/salesfractionpro/"
                target="_blank"
                rel="noreferrer"
                className="footer-linkedin"
              >
                <FaLinkedin aria-hidden="true" />
                <span>Company LinkedIn</span>
              </a>
            </div>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
